import { Photos } from './brick/photos';
import { Price } from './brick/price';
import { ShortDescription } from './brick/short-description';
import { Features } from './brick/features';
import { Tags } from './brick/tags';

export function SheetSmall({
  url,
  photos,
  price,
  currency,
  priceUnit,
  state,
  status,
  mandate,
  term,
  type,
  bedrooms,
  bathrooms,
  garages,
  openParking,
  coveredParking,
  floorSize,
  landSize,
  tags,
  listedAt,
}) {
  return (
    <a
      className={`property-card property-card_type_sheet property-card_size_small`}
      href={url}
      target={`_blank`}
    >
      <Photos urls={photos} />

      <div className={`property-card__details`}>
        <Tags tags={tags} state={state} mandate={mandate} listedAt={listedAt} />

        <Price
          price={price}
          currency={currency}
          priceUnit={priceUnit}
          status={status}
          term={term}
        />

        <ShortDescription
          type={type}
          status={status}
        />

        <Features
          bedrooms={bedrooms}
          bathrooms={bathrooms}
          garages={garages}
          openParking={openParking}
          coveredParking={coveredParking}
          floorSize={floorSize}
          landSize={landSize}
        />
      </div>
    </a>
  );
}
